export const rootRoute = '/rv/insurance/';
export const lifeInsuranceRoute = rootRoute + 'life-insurance/';
export const motorInsuranceRoute = rootRoute + 'motor-insurance/';
export const coronaInsuranceRoute = rootRoute + 'corona-virus-insurance/';
export const standaloneInsuranceRoute = rootRoute + 'standalone-insurance/';
export const deviceInsuranceRoute = rootRoute + 'device-insurance/';

export const insuranceType = {
  lifeInsurance: 'life-insurance',
  motorInsurance: 'motor-insurance',
  coronaVirus: 'corona-virus-insurance',
  standaloneInsurance: 'standalone-insurance',
  deviceInsurance: 'device-insurance',
  motorInsurance4W: 'motor-insurance-4w',
  motorInsurance2W: 'motor-insurance-2W'
};

export const apiBaseUrl = '163.53.79.29';
export const apiPaths = {
  fetchPage: '/4/insurance/page/fetch',
  fetchPageProd: '/4/page/fetch',
  fetchDocument: '/3/page/fetch',
  fetchPlan: {
    [insuranceType.lifeInsurance]:
      '/1/insurance/life-insurance/landing-page/categoryType/LIFE_INSURANCE',
    [insuranceType.coronaVirus]:
      '/1/insurance/life-insurance/landing-page/categoryType/CORONA_VIRUS_INSURANCE',
    [insuranceType.standaloneInsurance]:
      '/1/insurance/life-insurance/landing-page/categoryType/STANDALONE_INSURANCE',
    [insuranceType.deviceInsurance]: '/1/insurance/device-insurance'
  }
};
export const HttpStatusCodes = {
  UNAUTHORIZED: 401,
  DC_SWITCH: 406,
  AAPI_KEVLAR_REFRESH_CODE: 206,
  TOO_MANY_REQUESTS: 429,
  UNASSIGNED_FROM_AAPI_NGINX: 433
};

export const CALVIN_DC_ID = '1';
export const KEVLAR_IOS_MIN_APP_VERSION = '9.89.4';
export const KEVLAR_ANDROID_MIN_APP_VERSION = '1790000';

export const kevlarResponseConstants = {
  AAPI_KEVLAR_REFRESH_ERROR_CODE: 4000,
  MAX_RETRY_REFRESH_AT_COUNT: 3,
  REFRESH_TOKEN_API_TIMEOUT: 10
};

export const networkErrorMessage = [
  'Failed to fetch',
  'Network request failed'
];
